import * as React from 'react';

import { IconProps } from '../Icon';

export const FactoryOutlineIcon = ({
  width,
  color,
}: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_COLOR = 'none';

  return (
    <svg
      aria-hidden="true"
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 512 512"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m390 234.189-60 20v-104.189h-90v134.189l-30 10v-60l-60 20v-104.189h-90v134.189l-60 20v207.811h512v-212h-122zm-120-54.189h30v84.189l-30 10zm-180 0h30v84.189l-30 10zm332 302h-92v-92h92zm60-152v152h-30v-122h-152v122h-270v-156.189l150-50v60l180-60v54.189z" />
        <path d="m60 450h210v-90h-210zm90-30v-30h30v30zm90 0h-30v-30h30zm-150-30h30v30h-30z" />
        <path d="m235.789 120h216.211c33.084 0 60-26.916 60-60s-26.916-60-60-60c-21.528 0-41.188 11.704-51.771 30h-68.384c-43.311 0-80.896 29.345-91.398 71.362zm96.057-60h88.496l3.546-9.976c4.257-11.977 15.554-20.024 28.112-20.024 16.542 0 30 13.458 30 30s-13.458 30-30 30h-174.516c11.501-18.307 31.79-30 54.362-30z" />
        <path d="m239.552 48.638 4.66-18.638h-92.365c-43.311 0-80.895 29.345-91.398 71.362l-4.661 18.638h92.365c43.311 0 80.895-29.345 91.399-71.362zm-87.705 11.362h50.668c-11.501 18.308-31.79 30-54.361 30h-50.669c11.501-18.308 31.79-30 54.362-30z" />
      </g>
    </svg>
  );
};
